import React from "react";

export default function Mymodal({ children, display }) {
  const clases = display ? "main-modal show" : "main-modal";
  return <div className={clases}>{children}</div>;
}
